import {GetStaticPaths, GetStaticProps, NextPage} from 'next';
import Layout from '@common/layout';
import React from 'react';
import {wrapper} from '@redux/index';
import {EPage, ISSRParams, IStaticPathParam, TLang} from '@common/types';
import {END} from 'redux-saga';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import {getProject} from '@redux/projects/actions';
import {ProjectDetail} from '@modules/Projects/views/ProjectDetail';
import {getContacts} from '@redux/contacts/actions';
import {getStrapiQuery} from '@common/functions';
import {IStrapiAttributes, IStrapiData} from '@redux/types';
import {IProject} from '@redux/projects/types';
import api from '@api/index';
import {getAppSettings, setApp} from '@redux/app/actions';
import {STATIC_PATCH_LOCALE_QUERY} from '@common/constants';

const ProjectPage: NextPage = () => {
  const {project} = useTypedSelector(state => state.projects)

  return (
    <Layout
      title={project?.meta?.title}
      description={project?.meta?.description}
      pipelineId={project?.meta?.pipelineId}
    >
      <ProjectDetail/>
    </Layout>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const query = getStrapiQuery(STATIC_PATCH_LOCALE_QUERY)
  const res: IStrapiData<IStrapiAttributes<IProject>[]> = await api.get('/projects/', {query})
  let enPaths: IStaticPathParam[] = []
  let paths = res.data.filter(p => !p.attributes.meta?.onlyPreview).map(p => {
    if (!!p.attributes?.localizations?.data?.length) {
      enPaths.push({
        params: {slug: p.attributes.slug},
        locale: 'en'
      })
    }
    return {
      params: {slug: p.attributes.slug},
      locale: 'ru'
    }
  })
  paths = [...paths, ...enPaths].flat()
  return {paths, fallback: false}
}

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(store => async ({...etc}) => {
  const {slug} = etc.params as ISSRParams
  const locale = etc.locale as TLang
  store.dispatch(setApp({page: EPage.PROJECT_PAGE, draftMode: etc.draftMode ?? false}))
  store.dispatch(getAppSettings({locale}))
  store.dispatch(getContacts({locale}))
  store.dispatch(getProject({slug: String(slug), locale}))
  store.dispatch(END)
  await store?.sagaTask.toPromise()

  return {
    props: {}
  }
})

export default ProjectPage
